import { unref, type MaybeRef } from 'vue'
import { respondEventBus } from './respond-event-bus'

export function useCancelRespond(chatId: MaybeRef<number>) {
  return () => respondEventBus.emit(unref(chatId), null)
}
